import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { inr0, fmtDate } from "@/lib/format";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";

const TYPE_STYLE = {
  rent_due: { c: "bg-blue-500", label: "Rent Due" },
  agreement_expiry: { c: "bg-amber-500", label: "Agreement Expiry" },
  expense: { c: "bg-rose-500", label: "Expense" },
  payment: { c: "bg-emerald-500", label: "Payment" },
};

export default function CalendarPage() {
  const [events, setEvents] = useState([]);
  const [cursor, setCursor] = useState(new Date());
  useEffect(() => { api.get("/calendar").then(setEvents).catch(() => {}); }, []);

  const y = cursor.getFullYear(), m = cursor.getMonth();
  const first = new Date(y, m, 1).getDay();
  const days = new Date(y, m + 1, 0).getDate();
  const byDay = {};
  events.forEach((e) => { const d = new Date(e.date); if (d.getFullYear() === y && d.getMonth() === m) { const k = d.getDate(); (byDay[k] = byDay[k] || []).push(e); } });

  return (
    <div>
      <PageHeader title="Calendar" subtitle="Rent dues, expiries, payments & expenses" testid="calendar-header" />
      <div className="flex flex-wrap gap-3 mb-4">
        {Object.entries(TYPE_STYLE).map(([k, v]) => <div key={k} className="flex items-center gap-1.5 text-xs text-slate-600"><span className={`w-3 h-3 rounded-full ${v.c}`} />{v.label}</div>)}
      </div>
      <Card className="border-slate-200 shadow-sm p-4">
        <div className="flex items-center justify-between mb-4">
          <button onClick={() => setCursor(new Date(y, m - 1, 1))} className="px-3 py-1 rounded-md hover:bg-slate-100 text-slate-600">←</button>
          <h3 className="font-heading text-lg font-semibold">{cursor.toLocaleString("en", { month: "long", year: "numeric" })}</h3>
          <button onClick={() => setCursor(new Date(y, m + 1, 1))} className="px-3 py-1 rounded-md hover:bg-slate-100 text-slate-600">→</button>
        </div>
        <div className="grid grid-cols-7 gap-1 text-center text-xs font-semibold text-slate-400 mb-1">{["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d}>{d}</div>)}</div>
        <div className="grid grid-cols-7 gap-1">
          {Array.from({ length: first }).map((_, i) => <div key={`e${i}`} />)}
          {Array.from({ length: days }).map((_, i) => {
            const day = i + 1; const evs = byDay[day] || [];
            return (
              <div key={day} className="min-h-[84px] border border-slate-100 rounded-md p-1.5 text-left">
                <div className="text-xs font-medium text-slate-500">{day}</div>
                <div className="space-y-0.5 mt-1">
                  {evs.slice(0, 3).map((e, x) => <div key={x} className="flex items-center gap-1 text-[10px] truncate" title={e.title}><span className={`w-2 h-2 rounded-full shrink-0 ${TYPE_STYLE[e.type]?.c}`} /><span className="truncate text-slate-600">{e.amount ? inr0(e.amount) : e.title}</span></div>)}
                  {evs.length > 3 && <div className="text-[10px] text-slate-400">+{evs.length - 3} more</div>}
                </div>
              </div>
            );
          })}
        </div>
      </Card>
    </div>
  );
}
